import React, { useState } from 'react';

const TextSection = ({ title, description, children, collapsible = false, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleOpen = () => {
    if (collapsible) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <section className={`bg-white ${collapsible && !isOpen ? 'py-4 md:py-6' : 'py-12 md:py-20'}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          {title && (
            <div
              className={`flex justify-between items-center ${collapsible ? 'cursor-pointer' : ''}`}
              onClick={toggleOpen}
            >
              <h2 className={`text-2xl md:text-4xl font-bold text-gray-900 font-PlusJakartaSans ${!collapsible || isOpen ? 'mb-4 md:mb-6' : ''}`}>
                {title}
              </h2>
              {collapsible && (
                <div className={`text-3xl text-dark-dark-teal-400 transition-transform ${isOpen ? 'transform rotate-45' : ''}`}>
                  <i className="far fa-fw fa-plus"></i>
                </div>
              )}
            </div>
          )}
          <div className={`overflow-hidden transition-all duration-300 ${collapsible && !isOpen ? 'max-h-0' : 'max-h-[20000px]'}`}>
            {children ? (
              <div className="text-base md:text-lg text-gray-600 leading-relaxed font-Inter">
                {children}
              </div>
            ) : description && (
              <p className="text-base md:text-lg text-gray-600 leading-relaxed font-Inter text-center">
                {description}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextSection;
